package amazon.lastmile.inject

import app.nestbridge.feature.children.presentation.ChildDetailPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ChildDetailPresenterFactory::class)
public interface AppNestbridgeFeatureChildrenPresentationChildDetailPresenterFactory {
  @Provides
  @IntoSet
  public fun provideChildDetailPresenterFactoryFactoryMultibinding(childDetailPresenterFactory: ChildDetailPresenterFactory): Presenter.Factory = childDetailPresenterFactory
}
